import { connect } from "react-redux";
import VerifyEmail from "./";
import { Effects } from "@/store/settings/effects";

const mDp = {
  verifyEmail: Effects.email.verify
};

export default connect(null, mDp)(VerifyEmail);
